import { FC, useState } from 'react';
import { NudosButton, NudosGenericModal, NudosTextInput } from '../NudosComponents';
import { NudosLogo, XSign } from '../../assets/images/components/NudosComponents';
import { FALLBACK_FLAG_IMAGE_URL } from '../../constants/constants';
import './DoubleConfirmationModal.scss';

interface ICompanyNameInfo {
  companyName?: string;
  orderId?: number;
  destination?: string;
  countryFlag?: string;
}
export interface IDoubleConfirmationModal {
  title?: string;
  companyNameInfo?: ICompanyNameInfo;
  customCompanyInfoElement?: React.ReactNode;
  customActionDescriptionElement?: React.ReactNode;
  verificationText: string;
  loadingConfirmation?: boolean;
  handleClose?: () => void;
  handleConfirmationText?: (verificationText: string) => void;
  centerHeader?: boolean;
  customHeight?: number;
  customWidth?: number;
}

const DoubleConfirmationModal: FC<IDoubleConfirmationModal> = ({
  title = 'Entrega de productos',
  companyNameInfo = {
    companyName: 'Nombre Empresa',
    countryFlag: FALLBACK_FLAG_IMAGE_URL,
    destination: 'Juanita Castañeda',
    orderId: 1
  },
  customCompanyInfoElement,
  customActionDescriptionElement,
  verificationText = '',
  loadingConfirmation,
  handleClose,
  handleConfirmationText,
  centerHeader,
  customWidth,
  customHeight
}: IDoubleConfirmationModal) => {
  const [confirmationText, setConfirmationText] = useState<string>();
  const modalWidth = !!customWidth ? `${customWidth}px` : '';
  const modalHeight = !!customHeight ? `${customHeight}px` : '';

  const checkVerificationText = () => {
    const verificationTextWithoutSpaces = verificationText?.replace(/\s+/g, '');
    const confirmationTextWithoutSpaces = confirmationText?.replace(/\s+/g, '');
    return verificationTextWithoutSpaces === confirmationTextWithoutSpaces;
  };

  const closeModal = () => {
    if (handleClose) handleClose();
  };

  const updateConfirmationModal = () => {
    const validText = checkVerificationText();
    if (handleConfirmationText && validText && confirmationText) {
      handleConfirmationText(confirmationText);
    }
  };

  return (
    <NudosGenericModal
      modalContent={
        <div
          id="doubleConfirmationModal"
          style={{
            width: modalWidth,
            height: modalHeight
          }}
        >
          <div className="closeIconContainer" onClick={closeModal}>
            <XSign fill="#999999" />
          </div>
          <div className={`headerTitle ${centerHeader ? 'centerHeader' : ''}`}>
            <NudosLogo />
            <div className="titleText"> {title}</div>
          </div>
          <div className="defaultContent">
            {customCompanyInfoElement ? (
              customCompanyInfoElement
            ) : (
              <div className="companyNameContainer">
                <div className="name">{`${companyNameInfo?.companyName} - Orden N°${companyNameInfo?.orderId}`} </div>|
                <div className="lightName">{`Envío - ${companyNameInfo?.destination}`} </div>
                <img alt="flag-img" className="sizeFlag" src={companyNameInfo?.countryFlag} />
              </div>
            )}

            {customActionDescriptionElement ? (
              customActionDescriptionElement
            ) : (
              <div className="actionDescription">
                <div className="firtsLine">¿Estás seguro de que deseas realizar esta acción?</div>
                <div className="secondLine">
                  Para confirmar, escribe el siguiente texto en el campo de abajo y haz
                  <br /> clic en “Confirmar”
                </div>
                <div className="thirdLine">{verificationText}</div>
              </div>
            )}

            <div className="containerInputModal">
              <NudosTextInput
                placeholder="Escribe el texto indicado para confirmar"
                isFilled={!!confirmationText}
                componentSize="large"
                handleChange={e => {
                  setConfirmationText(e);
                }}
              />
            </div>
          </div>
          <div className="buttonsContainer">
            <NudosButton
              customWidth="280px"
              customHeight="38px"
              buttonText="Volver"
              colorPalette="secondary"
              isButtonDisabled={loadingConfirmation}
              handleClick={closeModal}
            />
            <NudosButton
              customWidth="280px"
              customHeight="38px"
              buttonText="Confirmar"
              isButtonLoading={loadingConfirmation}
              isButtonDisabled={!confirmationText || !checkVerificationText() || loadingConfirmation}
              handleClick={updateConfirmationModal}
            />
          </div>
        </div>
      }
    />
  );
};

export default DoubleConfirmationModal;
